import React from "react";
import cx from "classnames";
import styles from "../scss/DigitalAdvice.module.scss";
import { ICoverResults } from "../interfaces/IDigitalAdviceData";

interface IRecommendedCoverItems {
    label: string;
    covers: ICoverResults[];
}

const RecommendedCoverItems: React.FC<IRecommendedCoverItems> = (props) => {
    const { label, covers } = props;

    return (
        <div className={cx([styles["recommended-cover-items"]])}>
            {label && <label className={cx([styles["advice-heading"]])}>{label}</label>}

            {!!(covers && covers?.length) &&
                covers.map((cover) => (
                    <div
                        className={cx([
                            styles["advice-products"],
                            {
                                [styles["not-covered"]]: !cover.isChecked
                            }
                        ])}
                        key={cover.title}>
                        <img src={cover.imgUrl} />
                        <div className={styles["advice-products-info"]}>
                            <p>{cover.title}</p>
                            <span className={styles["advice-products-info--subtitle"]}>
                                {cover.subTitle}
                            </span>
                            <span>{cover.details}</span>
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default RecommendedCoverItems;
